var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "12px",
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 0,
    y: 0,
    width: 16,
    height: 11.4285714,
    rx: 1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B36B2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#042993",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD045",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECA2F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BA"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "FlagBackground",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask-Copy",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero",
    mask: "url(#mask-3)",
    x: 0,
    y: 0,
    width: 16,
    height: 11.4285714
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    fill: "url(#linearGradient-5)",
    fillRule: "nonzero",
    mask: "url(#mask-3)",
    points: "12.952381 11.4285714 16 11.4285714 16 0 4.95238095 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-2",
    fill: "url(#linearGradient-6)",
    fillRule: "nonzero",
    mask: "url(#mask-3)",
    points: "9.9047619 10.6666667 9.36601387 10.8244623 9.52380952 10.2857143 9.36601387 9.74696625 9.9047619 9.9047619 10.4435099 9.74696625 10.2857143 10.2857143 10.4435099 10.8244623"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-2",
    fill: "url(#linearGradient-7)",
    fillRule: "nonzero",
    mask: "url(#mask-3)",
    points: "8.38095238 8.38095238 7.84220434 8.53874804 8 8 7.84220434 7.46125198 8.38095238 7.61904762 8.91970042 7.46125198 8.76190476 8 8.91970042 8.53874804"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-2",
    fill: "url(#linearGradient-6)",
    fillRule: "nonzero",
    mask: "url(#mask-3)",
    points: "6.85714286 6.0952381 6.31839483 6.25303374 6.47619048 5.71428571 6.31839483 5.17553769 6.85714286 5.33333333 7.39589088 5.17553769 7.23809524 5.71428571 7.39589088 6.25303374"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-2",
    fill: "url(#linearGradient-6)",
    fillRule: "nonzero",
    mask: "url(#mask-3)",
    points: "5.33333333 3.80952381 4.79458531 3.96731945 4.95238095 3.42857143 4.79458531 2.88982341 5.33333333 3.04761905 5.87208136 2.88982341 5.71428571 3.42857143 5.87208136 3.96731945"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-2",
    fill: "url(#linearGradient-6)",
    fillRule: "nonzero",
    mask: "url(#mask-3)",
    points: "3.80952381 1.52380952 3.27077579 1.68160517 3.42857143 1.14285714 3.27077579 0.604109119 3.80952381 0.761904762 4.34827183 0.604109119 4.19047619 1.14285714 4.34827183 1.68160517"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBa);
export default __webpack_public_path__ + "static/media/BA.7bfd1f69f21d0ebcb39f83eb3ed427f5.svg";
export { ForwardRef as ReactComponent };